import { FC, ReactNode } from 'react';
import {
  cvaParkingIcon,
  cvaParkingIconCount,
  cvaParkingIconInner,
} from '~/entities/ParkingIcon/ParkingIconStyles';
import Union from '/public/icons/Union.svg?react';
interface Props {
  content: number | string | ReactNode;
}

export const ParkingIcon: FC<Props> = ({ content }) => {
  return (
    <div className={cvaParkingIcon()}>
      <div className={cvaParkingIconInner()}>
        <span className={cvaParkingIconCount()}>{content}</span>
      </div>
      <Union height={9} width={6} />
    </div>
  );
};
